import React from 'react';
import { StyleSheet, View, Platform, TouchableOpacity, Image } from 'react-native';
import { useTheme } from '@emotion/react';
import { ODSIcon } from '../../../atoms/ODSIcon';
import { ODSText } from '../../../atoms/ODSText';
import getScreenType from '../../../../utils/getScreenType';


const SavedPropertiesCard = ({
}) => {
  const { colors } = useTheme();
  const layoutType = getScreenType();

  return (
    <View style={{ flex: 1, ...styles.shadowBox }}>
      <View style={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'row', marginBottom: 12 }}>
        <ODSIcon icon={'TB-House-Fav'} size={24} color={colors.button.main} />
        <ODSText type='h5' marginLeft={12} color={colors.text.primary}>Saved Properties</ODSText>
      </View>
      <ODSText textAlign='center' type='sm' marginTop={12} color={colors.text.primary}>Download the app to see the saved properties.</ODSText>
      <View style={{ alignSelf: 'center', flexDirection: layoutType == "phone" ? 'column' : 'row', gap: 16, alignItems: 'center', marginTop: 32 }}>
        <TouchableOpacity onPress={() => window.open('https://apps.apple.com/in/app/tlyfe/id6449941281')}>
          <Image source={require('../../../../images/appstore.png')} style={{ width: 180, height: 52 }} />
        </TouchableOpacity>
        <TouchableOpacity onPress={() => window.open('https://play.google.com/store/apps/details?id=com.tlyfe&hl=en_IN&gl=US')}>
          <Image source={require('../../../../images/playstore.png')} style={{ width: 180, height: 52 }} />
        </TouchableOpacity>
      </View>
      {/* <ODSText textAlign='center'  type='md' marginTop={48} color={colors.text.primary}>Coming soon!</ODSText> */}
    </View>
  );
};
const styles = StyleSheet.create({
  shadowBox: {
    backgroundColor: '#fff',
    marginHorizontal: 20,
    paddingVertical: 32,
    borderRadius: 12,
    ...Platform.select({
      ios: {
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 3 },
        shadowOpacity: 0.15,
        shadowRadius: 8,
      },
      android: {
        elevation: 4,
      },
      web: {
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 3 },
        shadowOpacity: 0.15,
        shadowRadius: 8,
      }
    }),
  },
});


export default SavedPropertiesCard;
